import React from "react";
import { Box, Flex } from "rebass";
import styled from "styled-components";

const Wrapper = styled(Box)`
  flex: 1;
  width: 100%;
`;

Wrapper.defaultProps = {};

const Container = styled(Box)``;

Container.defaultProps = {};

const PageContent = (props) => (
  <Wrapper>
    <Container>{props.children}</Container>
  </Wrapper>
);

PageContent.defaultProps = {};

export default PageContent;



// WEBPACK FOOTER //
// ./src/components/PageContent.js